import * as React from 'react';
// @ts-expect-error
import type {ActionMeta} from 'react-select';

import {colors} from 'shells/colors/colors';
import {SelectInline} from 'shells/select-inline/select-inline';

export type Option = {
    id: string;
    name: string;
    avatarUrl?: string;
    initials?: string;
    emailAddress?: string;
    primaryInfo?: string;
    type?: string;
    relatedName?: string;
    // Useful for passing around additional data with the option that isn't
    // necessarily used in this component
    metaData?: any;
};

type Props = {
    placeholder: string;
    value: Option[];
    onChange: (newValue: any, actionMeta: ActionMeta) => void;
    onBlur: () => void;
    onClearValue?: () => void;
    defaultOptions?: true | any[];
    loadOptions: (search: string) => Promise<Option[]>;
    noOptionsMessage?: (arg1: {inputValue: string}) => string | null;
    multi?: boolean;
    components?: any;
    labelKey?: string;
    valueKey?: string;
    clearable?: boolean;
    shouldStyleValueByType?: boolean;
    disabled?: boolean;
    hasDropdownIndicator?: boolean;
    searchable?: boolean;
    openMenuOnClick?: boolean;
    controlShouldRenderValue?: boolean;
    autoFocus?: boolean;
    isTwoLine?: boolean;
};

export function GraphQLSelectInline(props: Props) {
    const {multi = true} = props;

    const styles = {
        // @ts-expect-error
        valueContainer: (base) => ({
            ...base,
            padding: '2px 0',
            marginLeft: '8px',
        }),
        // Carousel has a max z-index of 21
        // @ts-expect-error
        menu: (base) => ({...base, zIndex: 22}),
        // @ts-expect-error
        control: (base, state) => {
            const hoverColor = state.isFocused ? colors.blue : colors.greyLt;
            const isInteractive = !props.disabled && props.searchable;

            return {
                ...base,
                '&:hover': {
                    border: isInteractive ? `1px solid ${hoverColor}` : undefined,
                },
                border:
                    state.isFocused && isInteractive
                        ? `1px solid ${colors.blue}`
                        : `1px solid ${colors.offWhiteMd}`,
                boxShadow: 'none',
                backgroundColor: '#fff',
                paddingTop: 5,
                marginLeft: 0,
                minHeight: 26,
                cursor: state.isDisabled || !props.searchable ? 'default' : 'pointer',
            };
        },
    } as const;

    return (
        <SelectInline
            {...props}
            multi={multi}
            defaultOptions={props.defaultOptions}
            tokenizedStyle='light'
            transparentBackground={true}
            styles={styles}
            hasDropdownIndicator={props.hasDropdownIndicator}
            searchable={props.searchable}
            openMenuOnClick={props.openMenuOnClick}
        />
    );
}
